<style lang="scss">
.comp-picker-link {
  .linktype-radio {
    margin-bottom: 6px;
    .el-radio {
      margin-right: 8px;
      &:last-child {
        margin-right: 0;
      }
    }
    .el-radio__label {
      padding-left: 2px;
      font-size: 13px;
    }
  }
  .btn-linkpath {
    padding: 0 8px;
    color: var(--themeColor);
    border: 1px solid var(--themeColor);
    background-color: #fff;
    font-size: 12px;
    height: 32px;
    line-height: 32px;
    border-radius: 3px;
    max-width: 200px;
      flex: 1;
    @include text-overflow();
  }
  input::-webkit-input-placeholder {
    font-size: 12px;
  }
  .el-input__inner {
    padding: 0 8px;
  }
}
</style>
<template>
  <div class="comp-picker-link">
    <!-- {{ localValue }} -->
    <el-radio-group v-if="isShowRadio" v-model="localValue.linkType" class="linktype-radio" @change="onChangeLinkType">
      <el-radio :label="0"> 选择路径 </el-radio>
      <el-radio v-if="isShowH5Link" :label="1"> H5链接 </el-radio>
    </el-radio-group>
    <div v-if="localValue.linkType == 0" class="btn-linkpath" @click="onPickerPath">
      {{ getLabelName() }}
    </div>
    <el-input
      v-else
      v-model="localValue.linkUrl"
      class="h5-link"
      size="small"
      type="text"
      placeholder="请填写自定义链接"
      @change="onChangeLinkUrl"
    />
    <slot/>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash'
import { mapGetters } from "vuex";
import { LINK_PATH } from '@/consts'
export default {
  name: 'CompPickerLink',
  props: {
    value: {
      type: [Object, Array],
      default: () => {}
    },
    platform: {
      type: String,
      default: ''
    },
    isShowH5Link: {
      // 不展示自定义链接label true：展示
      type: Boolean,
      default: false
    },
    isShowRadio:{
      type: Boolean,
      default: true
    },
    isNotice:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localValue: {
        linkType: 0,
        linkUrl: '',
        linkPage: '',
        id: '',
        title: ''
      }
    }
  },
  computed: {
    ...mapGetters([
      'template_name',
      'wxapp_id'
    ])
  },
  watch: {
    value: {
      immediate: true,
      deep:true,
      handler(nVal) {
        this.localValue = {
          ...this.localValue,
          ...nVal
        }
      }
    }
    // localValue: (nVal, oVal) => {
    //   this.$emit('input', nVal)
    // }
  },
  // created() {
  //   this.localValue = this.value
  // },
  methods: {
    async onPickerPath() {
      const { template_douyin = 0 } = this.$route.query
      const { linkPage, id } = this.localValue
      const res = await this.$picker.path({
        data: id,
        tab: linkPage,
        multiple: false,
        wxapp_id:this.wxapp_id,
        template_name:this.template_name,
        isDouyin:template_douyin==1||this.platform=='byte_mini',
        isHotWords: false,
        isNotice: this.isNotice
      })
      this.$emit('input', res)
      this.$emit('change', res)
    },
    onChangeLinkType() {
      this.$emit('input', this.localValue)
      this.$emit('change', this.localValue)
    },
    onChangeLinkUrl() {
      this.$emit('input', this.localValue)
      this.$emit('change', this.localValue)
    },
    getLabelName() {
      const { linkPage, title,id } = this.localValue
      if (linkPage) {
        return `${LINK_PATH[linkPage]}：[${id}]-${title}`
      } else {
        return '选择路径'
      }
    }
  }
}
</script>
